import Joi from 'joi';
import {
  currentYear,
  vehiclePurchaseDateMaxAsNumber,
  vehiclePurchaseDateMinAsNumber,
} from '../../utils';

export const markdownComponents = {
  p: ({ children }: any) => <p className="whitespace-pre-line">{children}</p>,
  a: ({ children, href }: any) => (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="underline break-word"
    >
      {children}
    </a>
  ),
};

export const fuelTypeOptions = [
  { value: 'diesel', label: 'expense.diesel' },
  { value: 'gas', label: 'expense.gas' },
  { value: 'LPG', label: 'expense.LPG' },
  { value: 'electric', label: 'expense.electric' },
  { value: 'hybrid', label: 'expense.hybrid' },
  { value: 'CNG', label: 'expense.CNG' },
];

export const usageTypeOptions = [
  {
    value: 'other',
    label: 'expense.vehicle_deductibility.min_private.label',
    desc: 'expense.vehicle_deductibility.min_private.desc',
  },
  {
    value: 'privateWithLogbook',
    label: 'expense.vehicle_deductibility.max_private.label',
    desc: 'expense.vehicle_deductibility.max_private.desc',
  },
  {
    value: 'professionalDriver',
    label: 'expense.vehicle_deductibility.professional.label',
    desc: 'expense.vehicle_deductibility.professional.desc',
  },
];

export const contractTypeOptions = [
  { value: 'userOwned', label: 'expense.userOwned' },
  { value: 'userLeased', label: 'expense.userLeased' },
  { value: 'userRented', label: 'expense.userRented' },
  { value: 'other', label: 'expense.other' },
];

export const VehicleFormValidationSchema = Joi.object({
  name: Joi.string()
    .min(2)
    .max(30)
    .required()
    .messages({ '*': 'expense.name_must_be_between_2_and_30_characters' }),

  fuelType: Joi.string()
    .required()
    .messages({ '*': 'expense.please_select_fuel_type' }),

  co2Emission: Joi.when('fuelType', {
    is: Joi.string().not('electric'),
    then: Joi.number().required().min(0).max(999),
  }).messages({ '*': 'expense.emission_must_be_between_0_and_999' }),
  weight: Joi.when('fuelType', {
    is: Joi.string().equal('hybrid'),
    then: Joi.number().required().min(10).max(5000),
  }).messages({ '*': 'expense.weight_must_be_between_10_and_5000' }),
  batteryCapacity: Joi.when('fuelType', {
    is: Joi.string().equal('hybrid'),
    then: Joi.number().required().min(0).max(500),
  }).messages({ '*': 'expense.battery_capacity_must_be_between_0_and_500' }),
  fiscalHorsepower: Joi.when('fuelType', {
    is: Joi.string().equal('CNG'),
    then: Joi.number().required().min(1).max(5000),
  }).messages({ '*': 'expense.horsepower_must_be_between_1_and_5000' }),

  registrationYear: Joi.number()
    .required()
    .min(1900)
    .max(currentYear)
    .messages({
      '*': 'expense.year_of_registration_must_be_1900_and_current_year',
    }),
  orderDate: Joi.number()
    .min(vehiclePurchaseDateMinAsNumber)
    .max(vehiclePurchaseDateMaxAsNumber)
    .required()
    .messages({
      'date.min': 'vehicle.orderDate.date.min',
      'date.max': 'vehicle.orderDate.date.max',
      '*': 'vehicle.orderDate.date.empty',
    }),
  usageType: Joi.string()
    .required()
    .messages({ '*': 'expense.please_select_usage_type' }),
  contractType: Joi.string()
    .required()
    .messages({ '*': 'expense.please_select_contract_type' }),
});
